/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemReEnterSetting } from './formPagePropertyItemReEnterSetting';
import { FormPagePropertyItemMailAddressErrorMessage } from './formPagePropertyItemMailAddressErrorMessage';
import { FormPagePropertyItemMailAddressInputFormat } from './formPagePropertyItemMailAddressInputFormat';


export interface FormPagePropertyItemMailAddressAllOf { 
    type: FormPagePropertyItemMailAddressAllOf.TypeEnum;
    format: FormPagePropertyItemMailAddressAllOf.FormatEnum;
    /**
     * 入力可能な最大文字数。固定で4000文字。
     */
    maxLength: number;
    reEnter?: FormPagePropertyItemReEnterSetting;
    inputFormat: FormPagePropertyItemMailAddressInputFormat;
    errorMessage?: FormPagePropertyItemMailAddressErrorMessage;
}
export namespace FormPagePropertyItemMailAddressAllOf {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
    export type FormatEnum = 'email';
    export const FormatEnum = {
        Email: 'email' as FormatEnum
    };
}



